import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import { API_GET_WABAHEALTH } from "../../api/company.service";

const toneByStatus = {
  active: "success",
  connected: "success",
  green: "success",
  flagged: "warning",
  yellow: "warning",
  banned: "danger",
  red: "danger",
  unavailable: "info",
  unknown: "info",
};

const labelByStatus = {
  green: "High",
  yellow: "Medium",
  red: "Low",
};

const formatStatusLabel = (status) => {
  const normalized = String(status || "unknown").toLowerCase();
  return labelByStatus[normalized] || normalized;
};

export const WabaHealth = () => {
  const [loading, setLoading] = useState(false);
  const [wabaHealthInfo, setWabaHealth] = useState([]);
  const { companyId } = useParams();

  useEffect(() => {
    setLoading(true);
    API_GET_WABAHEALTH(companyId)
      .then((data) => {
        const wabaHealth = data?.wabaInfo || {};
        const details = [
          {
            status: wabaHealth?.accountStatus?.toLowerCase() || "unknown",
            label: "Account Status",
            id: "account-status",
          },
          {
            status: wabaHealth?.dockerStatus?.toLowerCase() || "unknown",
            label: "Docker Status",
            id: "docker-status",
          },
          {
            status: wabaHealth?.messagingLimit?.toLowerCase() || "unknown",
            label: "Message Limit",
            id: "message-limit",
          },
          {
            status: wabaHealth?.phoneQuality?.toLowerCase() || "unknown",
            label: "Phone Quality",
            id: "phone-quality",
          },
        ];

        if (wabaHealth?.accountStatus?.toLowerCase() === "banned") {
          setWabaHealth([details[0]]);
        } else {
          setWabaHealth(details);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err?.response?.data?.message);
        setLoading(false);
      });
  }, [companyId]);

  if (loading) {
    return (
      <>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index}
            width="100%"
            height="6.5rem"
            borderRadius="18px"
          />
        ))}
      </>
    );
  }

  return (
    <>
      {wabaHealthInfo.map((item) => (
        <div className="company-insight-card" key={item.id}>
          <span>{item.label}</span>
          <strong>{formatStatusLabel(item.status)}</strong>
          <div
            className={`status-pill ${toneByStatus[item.status] || "info"}`}
            style={{ marginTop: "0.8rem", width: "fit-content" }}
          >
            <i className="pi pi-circle-fill" style={{ fontSize: "0.55rem" }} />
            {item.status}
          </div>
        </div>
      ))}
    </>
  );
};
